import { alpha, LinearProgress, MenuItem, styled } from '@mui/material';

const PREFIX = 'RefreshGPCOption';

export const refreshGPCOptionClasses = {
  content: `${PREFIX}-content`,
  icon: `${PREFIX}-icon`,
  meta: `${PREFIX}-meta`,
  title: `${PREFIX}-title`,
};

export const RefreshGPCOptionRoot = styled('div')({
  margin: 0,
});

export const RefreshGPCOptionProgress = styled(LinearProgress)(({ theme }) => ({
  height: 2,
  margin: theme.spacing(0, 0, 0.5),
  borderRadius: theme.shape.radius.xs,
  backgroundColor: alpha(theme.palette.success.main, 0.12),
  '& .MuiLinearProgress-bar': {
    backgroundColor: theme.palette.success.main,
  },
}));

export const RefreshGPCOptionMenuItem = styled(MenuItem)(({ theme }) => ({
  alignItems: 'center',
  boxSizing: 'border-box',
  display: 'flex',
  gap: theme.spacing(1),
  minHeight: 40,
  padding: theme.spacing(1),
  borderRadius: theme.shape.radius.xs,
  color: theme.palette.navigation.primary.menu.item.secondaryText,
  transition: theme.transitions.create(['background-color', 'color'], {
    duration: theme.transitions.duration.shortest,
    easing: theme.transitions.easing.easeInOut,
  }),
  width: '100%',
  '&:hover, &.Mui-focusVisible, &:focus-visible': {
    backgroundColor: theme.palette.navigation.primary.menu.item.hoverBackground,
    color: theme.palette.navigation.primary.menu.item.primaryText,
    [`& .${refreshGPCOptionClasses.icon}, & .${refreshGPCOptionClasses.title}, & .${refreshGPCOptionClasses.meta}`]: {
      color: theme.palette.navigation.primary.menu.item.primaryText,
    },
  },
  [`& .${refreshGPCOptionClasses.icon}`]: {
    alignItems: 'center',
    color: theme.palette.success.main,
    display: 'inline-flex',
    flexShrink: 0,
    height: 16,
    justifyContent: 'center',
    width: 16,
    '& svg': {
      fontSize: 16,
    },
  },
  [`& .${refreshGPCOptionClasses.content}`]: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    minWidth: 0,
  },
  [`& .${refreshGPCOptionClasses.title}`]: {
    color: theme.palette.success.main,
    fontSize: theme.typography.caption.fontSize,
    fontWeight: 600,
    lineHeight: theme.typography.caption.lineHeight,
  },
  [`& .${refreshGPCOptionClasses.meta}`]: {
    color: theme.palette.navigation.primary.menu.item.secondaryText,
    fontSize: 10,
    fontWeight: 500,
    lineHeight: '14px',
  },
}));
